import { Track } from "@models/track";
import Image from "next/image";
import { Wrapper } from "./Artwork.style";
import { dynamicImageUrl } from "@/src/lib/utils/dynamicImageUrl";

interface Props {
	playlist: Track[];
	currentTrack: Track;
	onPlay: (track: Track) => void;
}

const Artwork: React.FC<Props> = ({ currentTrack }) => {
	return (
		<Wrapper>
			<Image
				key={`artwork-track-${currentTrack.id}`}
				className="current"
				src={dynamicImageUrl({ imageUri: currentTrack.release.image?.uri, size: "sm" })}
				alt={currentTrack.name}
				width={56}
				height={56}
			/>
		</Wrapper>
	);
};

export default Artwork;
